module.exports = __webpack_public_path__ + "braster-logo-app.png?fab40fd0576eb0cdcf5a5850f505f8b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/braster-logo-app.png
// module id = 191
// module chunks = 0